/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-08-21 08:58:54
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-12 09:18:59
 */
/*
 * state
 * */
import storage from './storage';

export default {
  isLogin: storage.getSessionItem('isLogin'), // 是否登录
  userMsg: storage.getSessionItem('userMsg'), // 用户信息
  menuListAll: [],  // 菜单menu列表
  tabsList: [],  // tabs标签栏
  breadNameList: [],  // 面包屑导航名
  defaultTheme: storage.getLocalItem('defaultTheme') || '#1890ff', // 主题色
  activeMenu: storage.getSessionItem('activeMenu'), // 展开menu项目
  addressList: storage.getLocalItem('addressList'),  // 地址列表
  activeMenuList: storage.getLocalItem('activeMenuList') || [], // 更新常用菜单
  contentSrc: storage.getSessionItem('contentSrc') || '', // contentSrc
  // menuIsHidden : storage.getItem('menuIsHidden'), // 左侧菜单是否隐藏
  // 数据词典
  orgTypeList: storage.getLocalItem('orgTypeList'), // 组织类型查询 【10-小区,11-社区,12-街道】
  orgSubTypeList: storage.getLocalItem('orgSubTypeList'), // 组织子类型查询 【D-部门,F-楼层楼宇结构,N-默认】
  positionType: storage.getLocalItem('positionType'), // 可见范围获取【01-所有人员,02-小区人员,03-小区业主】
  visitedScopeType: storage.getLocalItem('visitedScopeType'), // 可见范围获取【01-所有人员,02-小区人员,03-小区业主】
  visitedScopeTypeTwo: storage.getLocalItem('visitedScopeTypeTwo'), // 可见范围获取-swiper 【01-所有人员,02-小区人员,03-小区业主】
  publishStatus: storage.getLocalItem('publishStatus'), // 上架状态获取 【01-上架,02-下架】
  advertiseType: storage.getLocalItem('advertiseType'), // 公告类型获取
  moduleJsonType: storage.getLocalItem('moduleJsonType'), // 权限--模块类型获取 【module-模块,menu-菜单,page-页面,operation-操作】
  moduleSubJsonType: storage.getLocalItem('moduleSubJsonType'), // 权限--模块类型获取 【add-新增,del-删除,mod-修改,list-列表,detail-详情,imp-导入,exp-导出,status-状态】
  userIdJsonType: storage.getLocalItem('userIdJsonType'), // 权限--证件类型获取 【1-身份证】
  userSexyJsonType: storage.getLocalItem('userSexyJsonType'), // 权限--性别获取 【1-男,2-女,N-保密】
  moduleTypeList: storage.getLocalItem('moduleTypeList'), // 模块分类  【00-应用,01-菜单】
};



// WEBPACK FOOTER //
// ./src/store/state.js